import { useState } from 'react';

export const STEP_ONE = 1;
export const STEP_TWO = 2;
export const STEP_THREE = 3;

const useStep = () => {
  const [step, setStep] = useState(STEP_ONE);
  const onNext = () => {
    if (step < 3) setStep(prev => prev + 1);
  };
  const onBack = () => {
    if (step > 1) setStep(prev => prev - 1);
  };

  return { step, onNext, onBack };
};

export default useStep;
